module.exports = __webpack_public_path__ + "img/whatwedo.1e0b7f05.png";